import CheckCircle from "../../icon/CheckCircle";
import InformationCircle from "../../icon/InformationCircle";
import CloseCircle from "../../icon/CloseCircle";
import React from "react";
import "./style.css";
import TriangleExclamation from "../../icon/TriangleExclamation";

/**
 *
 * @param props
 * @returns {*}
 * @constructor
 */
export default function Alert({
                                  type = "info",
                                  title,
                                  description,
                                  className,
                                  nobg = false,
                                  minimal = false,
                                  hideIcon = false,
                                  ...props
                              }) {
    const alertClass = () => {
        let css = `${minimal ? "alert-box-mini" : "alert-box"}${nobg ? " nobg" : ""}`;
        if (type === "warning") {
            css = `${css} alert-warning`;
        } else if (type === "error") {
            css = `${css} alert-error`;
        } else if (type === "success") {
            css = `${css} alert-success`;
        } else if (type === "info") {
            css = `${css} alert-info`;
        }
        return css;
    };

    return (
        <div className={`${alertClass()} ${className}`} {...props}>
            <div className="d-flex">
                {!hideIcon && <div className="alert-icon-box">
                    {type === "warning" && (
                        <TriangleExclamation
                            className="alert-icon"
                            aria-hidden="true"
                        />
                    )}
                    {type === "error" && (
                        <CloseCircle className="alert-icon" aria-hidden="true"/>
                    )}
                    {type === "success" && (
                        <CheckCircle
                            className="alert-icon"
                            aria-hidden="true"
                        />
                    )}
                    {type === "info" && (
                        <InformationCircle
                            className="alert-icon"
                            aria-hidden="true"
                        />
                    )}
                </div>}
                <div className={`${hideIcon ? "" : "alert-message-box"}`}>
                    {title &&
                        <h3 className="alert-title">{title}</h3>
                    }
                    {description &&
                        <div className="alert-description">
                            {description}
                        </div>
                    }
                </div>
            </div>
        </div>
    );
}
